<template>
  <div class="front-container">
    <div class="header-nav">
      <div ref="parent" class="header-left-warp">
        <div class="logo-warp">
          <div class="logo">
            <img src="../../../public/logo.svg" alt="" />
          </div>
          <div :class="{'logo-text1': this.isNavCollapsed, 'logo-text': !this.isNavCollapsed}">{{ projectName }}</div>
        </div>
        <div  :class="{'header-navs': this.isNavCollapsed, 'header-navs1': !this.isNavCollapsed}">
          <el-menu v-if="!isNavCollapsed"
            router
            :default-active="$route.path"
            mode="horizontal"
            @select="handleSelect">
            <!--前台路由-->
            <el-menu-item index="/front/home" class="ttl-tex">首页</el-menu-item><!--href="https://www.shangui123.top/"-->
            <el-menu-item index='/front/clothing' class="ttl-tex">服装分类</el-menu-item>
            <el-menu-item index='/front/article' class="ttl-tex">文献资料</el-menu-item>
            <el-menu-item index='/front/3Display' class="ttl-tex">三维展示</el-menu-item>
            <el-menu-item index='/front/ques' class="ttl-tex" @click="navigateToProjectB"><a target="_blank"> 智能问答</a></el-menu-item>
            <el-menu-item index='/front/about' class="ttl-tex">关于我们</el-menu-item>
            <el-menu-item index='/front/message' class="ttl-tex">联系我们</el-menu-item>
            <!--前台路由-->
          </el-menu>
          <el-menu v-else
                             router
                             :default-active="$route.path"
                             mode="horizontal"
                             @select="handleSelect"

                   text-color="black"
                   active-text-color= "green"
                             >
          <el-submenu index="2">
            <template slot="title">菜单</template>
            <el-menu-item index="/front/home" class="ttl-tex">首页</el-menu-item><!--href="https://www.shangui123.top/"-->
            <el-menu-item index='/front/clothing' class="ttl-tex">服装分类</el-menu-item>
            <el-menu-item index='/front/article' class="ttl-tex">文献资料</el-menu-item>
            <el-menu-item index='/front/3Display' class="ttl-tex">三维展示</el-menu-item>
            <el-menu-item index='/front/ques' class="ttl-tex" @click="navigateToProjectB"><a target="_blank"> 智能问答</a></el-menu-item>
            <el-menu-item index='/front/about' class="ttl-tex">关于我们</el-menu-item>
            <el-menu-item index='/front/message' class="ttl-tex">联系我们</el-menu-item>
          </el-submenu>

        </el-menu>
        </div>


      </div>
      <div class="user-warp">
        <div v-if="!user.id" class="btn-login">
          <el-button @click="$router.push('/login')">登录</el-button>
        </div>
        <div v-if="!user.id" class="btn-login" style="margin-left: 10px">
          <el-button @click="$router.push('/register')">注册</el-button>
        </div>
        <el-dropdown v-else>
          <div class="user-avatar">
            <img :src="user.avatarUrl" />
          </div>
          <el-dropdown-menu size="medium" slot="dropdown">
            <el-dropdown-item>{{ user.nickname }}</el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/front/person"><div>个人信息</div></router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/front/password"
                ><div>修改密码</div>
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/home"><div>后台管理</div></router-link>
            </el-dropdown-item>
            <el-dropdown-item
              ><div @click="logout">退出登录</div></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-content">
      <router-view @refreshUser="getUser"></router-view>
    </div>
  </div>
</template>

<script>
import { projectName } from "../../../config/config.default";
import CryptoJS from 'crypto-js';
export default {
  name: "",
  data() {
    return {
      isNavCollapsed: false, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      projectName: projectName,
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
    };
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    this.selectedButton = localStorage.getItem('selectedButton') || '';
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  /*beforeDestroy() {
    window.removeEventListener('resize', this.updateParentWidth);
  },*/
  methods: {
    handleNavClick(item) {
      // 处理导航按钮点击事件
      console.log(`Clicked: ${item.label}`);
      // 如果需要关闭下拉菜单，可以在这里设置 isNavExpanded = false;
    },
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    encryptText(data) {
      const ciphertext = CryptoJS.AES.encrypt(data, '2b7e151628aed2a6abf7158809cf4f3c').toString();
      console.log(ciphertext)
      return ciphertext
    },
    decryptText(data) {
      const bytes = CryptoJS.AES.decrypt(data,'2b7e151628aed2a6abf7158809cf4f3c');
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      console.log(originalText)
      return originalText
    },
    navigateToProjectB() {
      const password = '000000'; // Replace this with your actual password or fetch it dynamically
      // Assuming you're using Vue Router
      window.location.href = 'https://www.qhnc.online/?password=' + this.encryptText(password);

    },
    handleSelect(key, keyPath) {},
    logout() {
      this.$store.commit("logout");
      this.$message.success("退出成功");
    },
    getUser() {
      let username = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).username
        : "";
      if (username) {
        // 从后台获取User数据
        this.request.get("/user/username/" + username).then((res) => {
          // 重新赋值后台的最新User数据
          this.user = res.data;
        });
      }
    },
  },
};
</script>

<style lang="scss" scpoed>
@import url('../../assets/font/font.css');

.ttl-text {
  font-family: 'DFLS1B',serif;
  font-size: 18px;
  color: #f1f1f1;
}
.front-container {
  /* 设置背景图片 */
  background-color:#FFF5EE;

  /* 确保背景覆盖整个元素 */
  background-size: cover;
  min-height: 100vh;
  .header-nav {
    z-index: 1800;
    position: sticky;
    top: 0;
    height: 70px;
    background-color: rgba(128, 128, 128, 0.2);

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
//    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    .ttl-tex {
      font-family: 方正姚体;
      font-size: 18px;
      color: #000000;
    }
    .header-left-warp {
      margin-left: 20px;
      display: flex;
      align-items: center;
      .logo-warp {
        display: flex;
        align-items: center;
        .logo {
          width: 30px;
          height: 30px;
          margin-right: 5px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .logo-text {
          font-family: 方正姚体简体;
          font-size: 22px;
          font-weight: 500;
          color: #000000;
        }
        .logo-text1 {
          font-family: 方正姚体;
          font-size: 17px;
          font-weight: 500;
          color: #000000;
        }
      }
      .header-navs {
        /*margin-left: this;*/
        .el-menu {
          background: transparent;
        }
        .el-menu--horizontal {
          border: none;
        }
        .el-submenu__title {
          padding: 0;
          font-size: 17px !important;
          height: 35px;
          margin: 0 10px;
          display: flex;
          align-items: center;
        }
        .is-active {
          border-bottom: 2px solid var(--color-success);
          color: var(--color-success);
        }
      }
      .header-navs1 {
        margin-left: 100px;
        .el-menu {
          background: transparent;
        }
        .el-menu--horizontal {
          border: none;
        }
        .el-submenu__title {
          padding: 0;
          font-size: 17px !important;
          height: 35px;
          margin: 0 10px;
          display: flex;
          align-items: center;
        }
        .is-active {
          border-bottom: 2px solid var(--color-success);
          color: var(--color-success);
        }
      }
    }
    .user-warp {
      margin-right: 10px;
      margin-top: 5px;
      display: flex;
      .user-avatar {
        width: 40px;
        height: 40px;

        border-radius: 50%;
        overflow: hidden;
        border: 1px solid var(--color-primary);
        padding: 2px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
  .main-content {

  }
}
</style>
